/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import { CustomTextField } from '../../../../components/CustomTextField';

/**
 * Second step of the invite external user modal, the logged resident types the
 * contact information of the visitor they are inviting.
 *
 * @param {Object} props
 * @param {Function} props.t - Localization function.
 * @param {boolean} props.emptyFields - Marks the required fields left empty.
 * @param {Object} props.invitation - Form of the invitation being created.
 * @param {Function} props.handleChange - Updates the field the resident is typing on.
 */
const InviteExternalUserStep2 = ({ t, emptyFields, invitation, handleChange }) => {

    return (
        <div className={'row'}>
            <div className={'col-12'}>
                <p className={'font-color-general-950 fs-14px text-center'}>
                    {t('provide_the_required_information_to_create_and_send_the_visitor_invitation')}
                </p>

                <p className={'font-color-general-950 ibl-font-w-600 fs-14px text-center my-4 text-uppercase'}>
                    {t('enter_the_contact_information_of_the_visitor')}
                </p>
            </div>

            <div className={'col-sm-12 col-md-6'}>
                <CustomTextField
                    id={'txt_ieu_name'}
                    length={128}
                    name={'name'}
                    value={invitation?.name}
                    trans={'name'}
                    type={'text'}
                    disabled={false}
                    onChange={handleChange}
                    required={true}
                    emptyFields={emptyFields}
                    placeholder={t('enter_name')}
                />
            </div>

            <div className={'col-sm-12 col-md-6'}>
                <CustomTextField
                    id={'txt_ieu_last_name'}
                    length={128}
                    name={'lastName'}
                    value={invitation?.lastName}
                    trans={'last_name'}
                    type={'text'}
                    disabled={false}
                    onChange={handleChange}
                    required={true}
                    emptyFields={emptyFields}
                    placeholder={t('enter_last_name')}
                />
            </div>
        </div>
    );
};

export default InviteExternalUserStep2;
